
import React, { useState, useEffect } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

const HeroSlider = ({ sliders }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    // Helper for images
    // Helper for images
    const STORAGE_URL = window.location.hostname === 'localhost'
        ? 'http://localhost:8000'
        : 'https://api.goodbuytamizha.com';

    useEffect(() => {
        if (!sliders || sliders.length === 0) return;
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % sliders.length);
        }, 5000); // Change every 5 seconds

        return () => clearInterval(interval);
    }, [sliders]);

    if (!sliders || sliders.length === 0) {
        // Fallback or empty state if no sliders
        return (
            <div className="relative bg-gray-900 h-[500px] flex items-center justify-center">
                <div className="text-center">
                    <h1 className="text-4xl font-bold text-white sm:text-5xl md:text-6xl">
                        Welcome to GoodBuyTamizha
                    </h1>
                    <p className="mt-3 text-xl text-gray-300">
                        Connect with verified suppliers and discover quality products
                    </p>
                </div>
            </div>
        );
    }

    const prevSlide = () => {
        const isFirstSlide = currentIndex === 0;
        const newIndex = isFirstSlide ? sliders.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    };

    const nextSlide = () => {
        const isLastSlide = currentIndex === sliders.length - 1;
        const newIndex = isLastSlide ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
    };

    const goToSlide = (slideIndex) => {
        setCurrentIndex(slideIndex);
    };

    return (
        <div className="relative h-[500px] w-full m-auto group overflow-hidden">
            {/* Slider Content */}
            <div
                style={{ backgroundImage: `url(${STORAGE_URL}${sliders[currentIndex].image_path})` }}
                className="w-full h-full bg-center bg-cover duration-500 ease-in-out transition-all relative"
            >
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                    <div className="text-center px-4 max-w-4xl">
                        {sliders[currentIndex].title && (
                            <h2 className="text-4xl md:text-6xl font-bold text-white mb-4 drop-shadow-lg transition-transform duration-700 transform translate-y-0">
                                {sliders[currentIndex].title}
                            </h2>
                        )}
                        {/* Link Wrapper button if link exists */}
                        {sliders[currentIndex].link && (
                            <a
                                href={sliders[currentIndex].link}
                                className="inline-block mt-4 px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-md transition duration-300 shadow-lg"
                            >
                                Learn More
                            </a>
                        )}
                    </div>
                </div>
            </div>

            {/* Left Arrow */}
            <div className="hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] left-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer hover:bg-black/50 transition">
                <ChevronLeftIcon onClick={prevSlide} className="h-8 w-8" />
            </div>

            {/* Right Arrow */}
            <div className="hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] right-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer hover:bg-black/50 transition">
                <ChevronRightIcon onClick={nextSlide} className="h-8 w-8" />
            </div>

            {/* Dots */}
            <div className="absolute bottom-4 left-0 right-0 flex justify-center py-2 space-x-2">
                {sliders.map((_, slideIndex) => (
                    <div
                        key={slideIndex}
                        onClick={() => goToSlide(slideIndex)}
                        className={`cursor-pointer w-3 h-3 rounded-full transition-all duration-300 ${currentIndex === slideIndex ? 'bg-white w-6' : 'bg-white/50'
                            }`}
                    ></div>
                ))}
            </div>
        </div>
    );
};

export default HeroSlider;
